<template>
    <section class="main-content" aria-labelledby="region1">
        <div class="main-content__wrapper">
            <div class="not-found">
                <div class="not-found-top">
                    <H1 class="not-found-title" id="region1">404</H1>
                    <div class="not-found__card">
                        <div
                            class="not-found__card__body"
                            v-for="i in 4"
                            :key="i"
                        />
                        <div
                            class="not-found__card__header"
                            v-for="i in 2"
                            :key="i + 4"
                        >
                            <div class="not-found__card__header__logo" />
                            <div class="not-found__card__header__title" />
                        </div>
                        <div class="not-found__card__text">Void</div>
                    </div>
                </div>
                <div class="not-found-bottom">
                    <H2
                        >Oops! We can’t seem to find the page you were looking
                        for</H2
                    >
                    <P
                        >We try our best to keep you from saying “where’d that
                        form go?” but sometimes we have to ask ourselves
                        “where’d that page go?”</P
                    >
                    <Link to="/get-quote" tabindex="-1">
                        <Button class="transparent" @click="prev"
                            >Return to homepage</Button
                        >
                    </Link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { H1, H2, Link, P, Button } from "../../style";

export default {
  name: "NotFound",
  components: {
    H1,
    H2,
    Link,
    P,
    Button,
  },
  data() {
    return {};
  },
  methods: {
    prev() {},
  },
  head: {
    title: {
      inner: "Not found",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.main-content {
    width: 100%;
    height: calc(100vh - 3.875rem);
    padding: 0;
    box-sizing: border-box;
    background-color: $background-gray;
    margin-top: 3.875rem;

    &__wrapper {
        margin: 0 auto;
        padding: 0 $padding-wrapper-md;
    }

    .not-found {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 60px;

        &-top {
            display: flex;
            align-content: center;
            flex-direction: row;
            justify-content: flex-start;
            padding-bottom: 40px;
            width: 100%;
            max-width: 600px;
        }

        &-title {
            font-size: 60px;
            font-size: 20vw;
            font-weight: bold;
            margin: auto 0;
            color: $blue-navy;
            padding-bottom: 10px;
            padding-right: 8%;
        }

        &__card {
            flex-shrink: 0;
            width: 100%;
            max-width: 160px;
            border-radius: $border-radius-lg;
            background-color: $white;
            padding: $padding-lg;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            box-shadow: 0 4px 12px -3px rgba(0, 0, 0, 0.2);
            position: relative;

            &__header {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                padding-bottom: $padding-md;

                &__logo {
                    width: 20px;
                    height: 20px;
                    border-radius: $border-radius-sm;
                    background-color: $purple-med;
                    margin-right: 7px;
                    flex-shrink: 0;
                }

                &__title {
                    height: 6px;
                    width: 50%;
                    border-radius: 5px;
                    background-color: $gray-dark;
                }

                &:nth-child(2n) {
                    padding-bottom: 0;
                }
            }

            &__body {
                height: 6px;
                width: 90%;
                border-radius: $border-radius-md;
                background-color: $gray-dark;
                margin-bottom: 12px;

                &:first-child {
                    height: 10px;
                    width: 80%;
                    border-radius: $border-radius-lg;
                }

                &:nth-child(even) {
                    width: 50%;
                }

                &:nth-child(3n) {
                    background-color: $blue-gray-active;
                }
            }

            &__text {
                text-transform: uppercase;

                font-size: $font-size-md;
                font-weight: bolder;
                padding: 3px 17px;
                color: $red-active;
                border: $border-radius-lg solid $red-active;
                border-radius: $border-radius-lg;
                transform: translate(-50%, -50%) rotate(20deg);
                position: absolute;
                top: 50%;
                left: 50%;
                letter-spacing: 5px;
            }

            @media (min-width: $tablet-width) {
                &__header {
                    padding-bottom: $padding-md;
                }

                &__body {
                    margin-bottom: $padding-lg;
                }

                &__text {
                    transform: translate(-50%, -50%) rotate(25deg);
                    padding: 3px 27px;
                }
            }
        }

        &-bottom {
            display: flex;
            flex-direction: column;
            max-width: 600px;

            h2 {
                font-size: 26px;
            }

            p,
            a {
                padding-top: 20px;
            }

            p {
                color: $black;
                max-width: 600px;
            }

            a {
                margin-left: -10px;
                text-decoration: none;

                button {
                    background-color: transparent;
                }
            }
        }

        @media (min-width: $mobile-width) {
            width: 90%;
            margin: 0 auto;

            &-top {
                justify-content: flex-start;
            }

            &-title {
                padding-right: 40px;
            }

            h2 {
                font-size: $font-size-xxxl;
                line-height: 44px;
            }
        }

        @media (min-width: $tablet-width) {
            width: 70%;
            padding-top: 60px;

            &-title {
                font-size: 17vw;
            }

            &__card {
                max-width: 180px;
            }

            h2 {
                font-size: $font-size-xxxl;
                line-height: 44px;
            }
        }

        @media (min-width: $desktop-width) {
            &-title {
                font-size: 160px;
            }
        }
    }
}
</style>
